import React from 'react';
import {
  Button,
  CardActions,
  CardContent,
  CardMedia,
  styled,
  Typography,
} from '@mui/material';
import type { IQrcodeDoctor } from '../../../interfaces/qrcode-doctor.type';

interface IProps {
  doctor?: IQrcodeDoctor;
  next: VoidFunction;
}

function Info({ doctor, next }: IProps) {
  return (
    <>
      <CardContentWrap sx={{ padding: '32px 0 48px', width: '100%' }}>
        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
            mb: 2,
          }}
          fontSize={20}
          lineHeight='24px'
          fontWeight={600}
        >
          Оставьте отзыв о докторе!
        </Typography>

        <CardMedia
          component='img'
          sx={{ width: 120, mb: 2 }}
          image={doctor?.imageUrl}
          alt={doctor?.fio}
        />

        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
          }}
          fontSize={20}
          lineHeight='24px'
          fontWeight={700}
        >
          {doctor?.fio}
        </Typography>

        <Typography
          sx={{
            fontFamily: '"Nunito Sans", sans-serif',
            mb: 2,
          }}
          fontSize={16}
          lineHeight='24px'
          fontWeight={400}
        >
          {doctor?.profession}
          {doctor?.experience ? `, стаж ${doctor.experience}` : ''}
        </Typography>

        {doctor?.message ? (
          <Typography
            sx={{
              fontFamily: '"Nunito Sans", sans-serif',
              mb: 2,
            }}
            fontSize={16}
            lineHeight='24px'
            fontWeight={700}
          >
            {doctor.message}
          </Typography>
        ) : null}
      </CardContentWrap>

      <CardActions sx={{ justifyContent: 'flex-end', alignSelf: 'center' }}>
        <Button className='button success' onClick={next}>
          Далее {'>>'}
        </Button>
      </CardActions>
    </>
  );
}

const CardContentWrap = styled(CardContent)`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
`;

export default Info;
